import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CountChart from "../Common/Components/Charts/CountChart"
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import {orderBy} from "lodash"
import { getVeryShortCountLoadingSelector, getVeryShortCountSelector } from "./countSlice";

interface RunningPeriodsWidgetProps{
    id: string;
    header: string
}

const CountWidget = (props:RunningPeriodsWidgetProps) =>{
    const [chartData, updateChartData] = useState([]);
    const [dataProcessed, setDataProcessed] = useState<boolean>(false);

    const veryShortCount = useSelector(getVeryShortCountSelector);
    const loadingState = useSelector(getVeryShortCountLoadingSelector);

    useEffect(()=>{
        if(veryShortCount.length > 0){  
            const sortedData = orderBy(veryShortCount,"count","desc")
            updateChartData(sortedData.splice(0,10))
        }else{
            updateChartData([])
        }
        setDataProcessed(true);
    },[veryShortCount])

    useEffect(()=>{
        if (loadingState==="pending"){
            setDataProcessed(false)
        }
        if(loadingState === "rejected"){
            setDataProcessed(true);
        }
        if(loadingState === "fulfilled" && veryShortCount.length === 0){
            setDataProcessed(true);
        }
    },[loadingState])

    const handleChartClick = () =>{
        
    }


    if (!dataProcessed) return <Spinner text="data" />;
    if (chartData == null || loadingState === "rejected") {
        //proper error handling should be added with promise error response
        return (
            <ErrorMessage
                text={"Oops something went wrong, unable to get data."}
                id={props.id}
                header={props.header}
            />
        );
    }
    if (chartData != null && chartData.length == 0) {
        return (
            <ErrorMessage
                text={"No data found for selected filters."}
                id={props.id}
                header={props.header}
            />
        );
    }
    return (
        <Fragment>
            <CountChart data = {chartData} clickHandler ={handleChartClick} id="15" values="count" type="" series={{name:"test", unit:"unit", color:"black"}}/>
        </Fragment>
        )
}

export default CountWidget;